'use strict';

import template from 'commons/templates/calendar/CalendarList.ejs';
import RowTpl from 'commons/templates/calendar/CalendarListRow.ejs';

module.exports = Backbone.View.extend({
    tabName:   'div',
    leaveRequestModal: null,

    initialize: function(options) {
        this.leaveRequests = options.leaveRequests;
    },

    render: function() {
        this.$el.html(template({
            leaveRequests: this.leaveRequests,
            RowTpl: RowTpl,
            limit: this.limit
        }));
        this.appendleaveRequests(this.leaveRequests);
        return this;
    },

    appendleaveRequests: function(leaveRequests) {
        const promises = leaveRequests.map(leaveRequest => {
                    return leaveRequest.fetchEmployee()
                        .then((employee) => {
                                return Promise.all([
                                    employee.fetchCompanyLocation(),
                                    employee.fetchPosition()
                                    ]).then(() => employee);
                            })
                            .then(() => leaveRequest);
                });
        Promise.each(promises, leaveRequest => {
            this.$('tbody').append(RowTpl({
                leaveRequest: leaveRequest
            }));
            return Promise.resolve(true);
        });
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/calendar/CalendarList.js